
export const callNative = (params) => {
  let ran = navigator.userAgent
  let isAndroid = ran.indexOf('Android') > -1 || ran.indexOf('Linux') > -1
  let isIOS = !!ran.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  
  if (isAndroid && window.android) {
    //安卓原生
    window.android.callNative(JSON.stringify(params));
  } else if (isIOS && window.webkit) {
    //iOS原生
    window.webkit.messageHandlers.nativeCaller.postMessage(JSON.stringify(params));
  } else {
    //浏览器状态
    alert("此功能需要在客户端中使用");
  }
}
